const AVAILABLE_SEGMENTATIONS = Object.freeze({
  NONE: 'None',
  ZONE: 'Zone',
  LESION: 'Lesion',
  LESIONZONE: 'Lesion/Zone',
});

export { AVAILABLE_SEGMENTATIONS };
